import { useState } from 'react';
import { useLocale } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME } from './content';
import { Lines } from './Lines';
import { RequestForm } from './RequestForm';

/** Start from the business need: example requests populate the field and travel into the intake. */
export function Need() {
  const { locale } = useLocale(); const copy = HOME[locale].need;
  const [text, setText] = useState('');
  return (
    <section id={sectionId('need', locale)} className="need" data-tone="light" aria-labelledby="need-title">
      <div className="need__inner wrap">
        <div className="need__intro">
          <h2 id="need-title" className="section-title"><Lines lines={copy.title} /></h2>
          <p className="section-body">{copy.body}</p>
        </div>
        <div className="need__panel">
          <p className="need__examples-label" id="need-examples">{copy.examplesLabel}</p>
          <ul className="need__examples" aria-labelledby="need-examples">
            {copy.examples.map(example => (
              <li key={example}><button type="button" className="need__example" aria-pressed={text === example} onClick={() => setText(example)}>{example}</button></li>
            ))}
          </ul>
          <RequestForm label={copy.field} placeholder={copy.placeholder} action={copy.action} value={text} onChange={setText} />
        </div>
      </div>
    </section>
  );
}
